import {Injectable} from '@angular/core';
import {
  Koeffiziente,
  ModellVariablenKoefficienteM1
} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m1';

@Injectable({
  providedIn: 'root'
})
export class ModellvariantenKoeffizienteService {
  private readonly arrOfColumnNames = [
    'nurGrundlohn',
    'ohneZulagen',
    'ohneSonderzahlungen',
    'dummyVariablenfuerAusbildung',
    'pqRegression',
    'standardAnalyseModell'
  ];

  getPreparateKoefficienteM1data(
    data: Koeffiziente
  ): ModellVariablenKoefficienteM1 {
    const result = new ModellVariablenKoefficienteM1();
    for (const key in result) {
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        const element = result[key];
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let index = 0; index < this.arrOfColumnNames.length; index++) {
          const koefficientClmn = data[this.arrOfColumnNames[index]];
          element[this.arrOfColumnNames[index]] = koefficientClmn[key];
        }
      }
    }
    return result;
  }
}
